<template>
  <div class="AlternativeLocation">
    <div class="mb-2">
      <strong>{{ $t('components.sidebar.LocatieInformatieContent.alternative') }}
        <template v-if="isPlanModeActive && !disabled">
          <b-button
            size="sm"
            variant="primary"
            @click="showAlternativeLocations"
          >
            Kies
          </b-button>

          <b-button
            class="ml-1"
            size="sm"
            variant="danger"
            @click="$emit('select', null)"
          >
            x
          </b-button>
        </template>
      </strong>

      <InlineChargingpoint
        v-if="predecessorChargingpoint"
        :chargingpoint="predecessorChargingpoint"
      />
      <div
        v-else
        v-text="$t('none')"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import InlineChargingpoint from '@/components/common/InlineChargingpoint'

export default {
  components: { InlineChargingpoint },
  props: {
    predecessor: {
      type: Object,
      required: false,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('planmode', {
      isPlanModeActive: 'isActive',
      getChargingPointByUuid: 'getChargingPointByUuid',
    }),
    predecessorChargingpoint() {
      if (this.predecessor) {
        return this.getChargingPointByUuid({ uuid: this.predecessor.uuid }) ?? false
      }

      return false
    },
  },
  methods: {
    ...mapActions('planmode', ['showAlternativeLocations']),
  },
}
</script>
